export default async function(
    functionObj={},
    variableObject={},
    parameterObject={}
){
    try{
        const {inhouz_reserved_parameters_xyzh={}} = parameterObject;
        const {websocketFunction} = inhouz_reserved_parameters_xyzh;
        if(websocketFunction){
            websocketFunction({
                action : 'createWebsocketConnection'
            });
        }
        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableObject,
            hasError : false,
            errorPayload : undefined
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/createWebsocketConnectionParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}